export default __webpack_public_path__ + "static/media/icon-twitter.c8d644c5.svg";